export default "__VITE_ASSET__DmzxJi8w__"